import { render, staticRenderFns } from "./GestioneAttivitaProgettoViewComponent.vue?vue&type=template&id=d30259d0"
import script from "./GestioneAttivitaProgettoViewComponent.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaProgettoViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports